import { useCallback } from 'react';

import { NavigationErrorType } from '../services/nav/Enums';
import { handleNavigationError, NavigationError } from '../services/nav/Errors';

/**
 * Generic hook for handling form submission with navigation
 * Provides consistent error handling and put/post logic
 */
export const useFormSubmission = <T,>(
  isUpdate: boolean,
  submitFunction: (data: T, mode: "put" | "post") => Promise<void>
) => {
  const handleSubmission = useCallback(
    async (formData: T, successCallback: () => void) => {
      const mode = isUpdate ? "put" : "post";
      console.log("useFormSubmission: Starting submission", { mode, formData });
      try {
        await submitFunction(formData, mode);
        console.log(
          "useFormSubmission: Submission successful, calling success callback"
        );
        successCallback();
      } catch (error) {
        console.error("useFormSubmission: Submission failed", error);
        const formError = new NavigationError(
          NavigationErrorType.FORM_SUBMISSION_FAILED,
          `Form submission failed in ${mode} mode`,
          error as Error
        );
        handleNavigationError(formError, "useFormSubmission");
        throw formError; // Re-throw to allow component-level handling
      }
    },
    [isUpdate, submitFunction]
  );

  return { handleSubmission };
};
